interface AssociateProfile {
  readonly name: string;
  readonly alias: string;
  readonly location: string;
  readonly employeeId: string;
  readonly managersName: string;
  readonly managersAlias: string;
  readonly shift: string;
  readonly personId: string;
  readonly jobTitle: string;
  readonly totalAccommodatedDays?: number;
}

interface AssociateProfilePlacement {
  readonly placementType: AssociateProfilePlacementType;
  readonly accommodationStatus: string;
  readonly accommodationId: number;
  readonly externalCaseId: string;
  readonly accommodationType: string;
  readonly numSelectedJobs?: number;
  readonly additionalTags: Array<string>;
  readonly injury: string;
  readonly updatedAt: string;
  readonly updatedBy: string;
  readonly startAt: string;
  readonly endAt: string;
  readonly timeInStatus: string;
  readonly transferAt: string;
  readonly transferredFrom: string;
}

interface AssociateProfilePlacementsResponse {
  readonly pending: AssociateProfilePlacement[];
  readonly active: AssociateProfilePlacement[];
  readonly transferredIn: AssociateProfilePlacement[];
}

export enum AssociateProfilePlacementType {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  TRANSFERRED = 'TRANSFERRED',
}

export type { AssociateProfile, AssociateProfilePlacement, AssociateProfilePlacementsResponse };
